import axios from 'axios';

import { IAbsenceCalendar } from '@/shared/model/absence-calendar.model';

const baseApiUrl = 'api/absence-calendars';

export default class AbsenceCalendarService {
  public find(id: number): Promise<IAbsenceCalendar> {
    return new Promise<IAbsenceCalendar>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAbsenceCalendar): Promise<IAbsenceCalendar> {
    return new Promise<IAbsenceCalendar>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAbsenceCalendar): Promise<IAbsenceCalendar> {
    return new Promise<IAbsenceCalendar>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IAbsenceCalendar): Promise<IAbsenceCalendar> {
    return new Promise<IAbsenceCalendar>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
